import { render } from "./ProfileLogo.vue?vue&type=template&id=52313534&scoped=true"
import script from "./ProfileLogo.vue?vue&type=script&lang=js"
export * from "./ProfileLogo.vue?vue&type=script&lang=js"

import "./ProfileLogo.vue?vue&type=style&index=0&id=52313534&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52313534"]])

export default __exports__